//TODO: elementio temporal hasta que existan los iconos de POIs
// import IconPromise from 'components/widgets/IconPromise/IconPromise';
import { useSelector } from 'react-redux';
import { categoryState } from 'redux/slices/categorySlice';
// import { ReactComponent as Ic_Location_Dark } from 'resources/icons/Ic_Location_Dark.svg';
import {  poiCategoryIconsState } from 'redux/slices/iconsSlice';
import { getIcon } from 'utils/mapUtils';
import Image from 'components/commons/image/Image';



import './codePoi.scss';
import { TYPES_MARKERS } from 'utils/constants';
// import SvgIcon from 'components/commons/icons/SvgIcon';

interface ICodePoi {
  id?:string | number
  routeColor?:string
  light?:boolean
  styles?:React.CSSProperties;
  color?:string;
  onClick?:()=>void;
  categoryId: string;
}


export default function CodePoi(props:ICodePoi) {

  const { styles, onClick, categoryId, color } = props;
  const selectorPoiCategories = useSelector(categoryState);
  const selectorPoiIcons = useSelector(poiCategoryIconsState);
  const poiData = selectorPoiCategories?.find(p => Number(p.id) === Number(categoryId));

  return (
    <div className='codePoi' style={{ background: color || poiData?.color || '#489aca',...styles}} onClick={()=> onClick && onClick()}>
     <Image
      className='code-poi-img'
      src={ getIcon(poiData?.iconId || '245', selectorPoiIcons, TYPES_MARKERS.POI) }
      />
    </div>
  );
}
